import { render, staticRenderFns } from "./scratchCardPrize.vue?vue&type=template&id=89a65690&"
import script from "./scratchCardPrize.vue?vue&type=script&lang=ts&"
export * from "./scratchCardPrize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports